import type { Article } from "./types";
import catAdoption from "./jak-przygotowac-sie-do-adopcji-kota";

export const articles: Article[] = [catAdoption].sort(
  (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
);

export const getArticleBySlug = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export type { Article };
